
<template>
<div class="distribution">
  <div class="block">
    <el-date-picker
      v-model="duration"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :picker-options="pickerOptions2">
    </el-date-picker>
  </div>
  <div class="chart"></div>
</div>
</template>

<script>
import axios from 'axios'
import echarts from 'echarts'
import china from 'echarts/map/js/china'
// import el_data_picker from 'element-ui/lib/data-picker'

export default {
  created() {
    this._getCityData()
  },

  data() {
    return {
      legendArr: [],
      myChart: {},
      geoCoordMap: {},
      name: '散点图',
      pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        duration: '',
      }
  },

  watch: {
    duration: function (newQuestion, oldQuestion) {
      this._getMyChart()
    }
  },

  methods: {
    randomValue() {
      return Math.round(Math.random() * 1500)
    },

    initialize(options) {
      this.myChart = echarts.init(document.querySelector('.distribution .chart'))
      this.myChart.setOption(options, true)
      this.legendArr = options.series
      this.legendArr.forEach((data) => {
        data.selected = true;
      })
      window.addEventListener('resize', function() {
        this.myChart.resize()
      }.bind(this))
    },
    _getCityData() {
      axios.get('/static/city.json').then((res) => {
        this.geoCoordMap = res.data
        this.$nextTick(() => {
          this._getMyChart()
        })
      })
    },

    _getMyChart() {
        let options = {
          // backgroundColor: '#404a59',

          title: {
            show: true,
            text: '用户地区分布',
            textStyle: {
              color: '#000'
            },
            left: 'center',
            top: 15
          },
          tooltip: {},
          visualMap: {
            min: 0,
            max: 1500,
            color: '#000',
            left: 'left',
            top: 'bottom',
            splitNumber: 5,
            inRange: {
              color: ['#51D4EB', '#3BBCB0', '#2F9696', '#2A7484', '#255B78'],
            },
            textStyle: {
              color: '#000'
            },
          },
          geo: {
            map: 'china',
            roam: false,
            itemStyle: {
              normal: {
                borderColor: '#fff',
              },
              emphasis: {
                areaColor: null,
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 20,
                borderWidth: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            top: 30,
            bottom: 50
          },
          series: [
            {
              type: 'scatter',
              coordinateSystem: 'geo',
            },
            {
              name: '人数',
              type: 'map',
              geoIndex: 0,
              data: [{
                  name: '北京',
                  value: this.randomValue()
                },
                {
                  name: '天津',
                  value: this.randomValue()
                },
                {
                  name: '上海',
                  value: this.randomValue()
                },
                {
                  name: '重庆',
                  value: this.randomValue()
                },
                {
                  name: '河北',
                  value: this.randomValue()
                },
                {
                  name: '河南',
                  value: this.randomValue()
                },
                {
                  name: '云南',
                  value: this.randomValue()
                },
                {
                  name: '辽宁',
                  value: this.randomValue()
                },
                {
                  name: '黑龙江',
                  value: this.randomValue()
                },
                {
                  name: '湖南',
                  value: this.randomValue()
                },
                {
                  name: '安徽',
                  value: this.randomValue()
                },
                {
                  name: '山东',
                  value: this.randomValue()
                },
                {
                  name: '新疆',
                  value: this.randomValue()
                },
                {
                  name: '江苏',
                  value: this.randomValue()
                },
                {
                  name: '浙江',
                  value: this.randomValue()
                },
                {
                  name: '江西',
                  value: this.randomValue()
                },
                {
                  name: '湖北',
                  value: this.randomValue()
                },
                {
                  name: '广西',
                  value: this.randomValue()
                },
                {
                  name: '甘肃',
                  value: this.randomValue()
                },
                {
                  name: '山西',
                  value: this.randomValue()
                },
                {
                  name: '内蒙古',
                  value: this.randomValue()
                },
                {
                  name: '陕西',
                  value: this.randomValue()
                },
                {
                  name: '吉林',
                  value: this.randomValue()
                },
                {
                  name: '福建',
                  value: this.randomValue()
                },
                {
                  name: '贵州',
                  value: this.randomValue()
                },
                {
                  name: '广东',
                  value: this.randomValue()
                },
                {
                  name: '青海',
                  value: this.randomValue()
                },
                {
                  name: '西藏',
                  value: this.randomValue()
                },
                {
                  name: '四川',
                  value: this.randomValue()
                },
                {
                  name: '宁夏',
                  value: this.randomValue()
                },
                {
                  name: '海南',
                  value: this.randomValue()
                },
                {
                  name: '台湾',
                  value: this.randomValue()
                },
                {
                  name: '香港',
                  value: this.randomValue()
                },
                {
                  name: '澳门',
                  value: this.randomValue()
                }
              ]
            }
          ]
        }
        this.initialize(options)
    }
  }
}
</script>

<!-- 散点图 -->
<style scoped lang="scss">

.distribution {
  .chart {
    height: 800px;
    width: 1000px;
    transition: all 0.5s linear;
  }
}



</style>



// WEBPACK FOOTER //
// src/views/index/data-analysis/consumer/distribution.vue